export const numberToWords = (value) => {
  value = value.toString().split(",").join("");
  if (value === 0) return "Zero";

  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  // const scales = ["", "Thousand", "Lakh", "Crore"];

  let num = parseInt(value);
  let words = "";
  // let scaleIndex = 0;

  if (num >= 10000000) {
    const crore = Math.floor(num / 10000000);
    words += numberToWords(crore) + " Crore ";
    num %= 10000000;
  }

  if (num >= 100000) {
    const lakh = Math.floor(num / 100000);
    words += numberToWords(lakh) + " Lakh ";
    num %= 100000;
  }

  if (num >= 1000) {
    const thousand = Math.floor(num / 1000);
    words += numberToWords(thousand) + " Thousand ";
    num %= 1000;
  }

  if (num > 0) {
    if (num >= 100) {
      words += ones[Math.floor(num / 100)] + " Hundred ";
      num %= 100;
    }

    if (num > 0) {
      if (num < 10) {
        words += ones[num];
      } else if (num < 20) {
        words += teens[num - 10];
      } else {
        words += tens[Math.floor(num / 10)];
        if (num % 10 > 0) {
          words += " " + ones[num % 10];
        }
      }
    }
  }

  return words.trim();
};

/**
 * Rupee amount spelled out for the hint under an amount field,
 * e.g. 4060000 -> "₹ Forty Lakh Sixty Thousand". Returns "" for a blank or
 * non-numeric value so the hint simply does not render.
 */
export const amountInWords = (amount) => {
  const digits = `${amount ?? ""}`.replace(/[^0-9]/g, "");
  if (!digits || Number(digits) === 0) return "";
  const words = numberToWords(digits);
  return words ? `₹ ${words}` : "";
};
